import { Component, Input, OnChanges, ChangeDetectorRef } from '@angular/core'

import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-attendance-clock',
  imports: [CommonModule],
  templateUrl: './attendance-clock.component.html',
  styleUrls: ['./attendance-clock.component.scss']
})
export class AttendanceClockComponent implements OnChanges {
  //   @Input() progressData: any[] = []
  private _progressData: any[] = []

  @Input()
  set progressData(value: any[]) {
    this._progressData = value || []

    if (this._progressData.length) {
      this.generateArcs()
    }
  }

  get progressData() {
    return this._progressData
  }
  @Input() totalHours: string = '00h 00m'

  clockHours = [
    '00',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23'
  ]

  arcs: any[] = []
  constructor(private cdr: ChangeDetectorRef) {}
  generateArcs() {
    this.arcs = []

    const circumference = 754

    this.progressData.forEach((item: any) => {
      if (item.color === 'bg-transparent') {
        return
      }

      this.arcs.push({
        color: this.getColor(item.color),
        length: (circumference * parseFloat(item.width)) / 100,
        offset: 0
      })
    })

    // console.log('ARC READY', this.arcs)

    this.cdr.detectChanges()
  }

  getLabelX(index: number) {
    const angle = ((index * 15 - 90) * Math.PI) / 180

    return 180 + Math.cos(angle) * 150
  }

  getLabelY(index: number) {
    const angle = ((index * 15 - 90) * Math.PI) / 180

    return 180 + Math.sin(angle) * 150
  }

  ngOnChanges() {
    this.generateArcs()
    // console.log('arcs', this.arcs)
  }

  //   generateArcs() {
  //     this.arcs = []

  //     let circumference = 691

  //     let currentOffset = 0

  //     this.progressData.forEach((item: any) => {
  //       let value = parseFloat(item.width.replace('%', ''))

  //       let length = (circumference * value) / 100

  //       this.arcs.push({
  //         color: this.getColor(item.color),

  //         length: length,

  //         offset: -currentOffset
  //       })

  //       currentOffset += length
  //     })
  //   }

  //   getColor(color: string) {
  //     if (color.includes('success')) return '#22c55e'

  //     if (color.includes('warning')) return '#f59e0b'

  //     if (color.includes('info')) return '#3b82f6'

  //     return '#ffffff'
  //   }
  getColor(color: string) {
    // console.log('COLOR', color)

    switch (color) {
      case 'bg-success':
        return '#22c55e'

      case 'bg-warning':
        return '#f59e0b'

      case 'bg-info':
        return '#3b82f6'

      default:
        return '#ffffff'
    }
  }

  getX(index: number) {
    let angle = ((index * 15 - 90) * Math.PI) / 180

    return 160 + Math.cos(angle) * 140
  }

  getY(index: number) {
    let angle = ((index * 15 - 90) * Math.PI) / 180

    return 160 + Math.sin(angle) * 140
  }
}
